/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeTranslation
 */
export interface AttributeTranslation {
    /**
     * 
     * @type {string}
     * @memberof AttributeTranslation
     */
    nameLocal?: string;
}

export function AttributeTranslationFromJSON(json: any): AttributeTranslation {
    return AttributeTranslationFromJSONTyped(json, false);
}

export function AttributeTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeTranslation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nameLocal': !exists(json, 'nameLocal') ? undefined : json['nameLocal'],
    };
}

export function AttributeTranslationToJSON(value?: AttributeTranslation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nameLocal': value.nameLocal,
    };
}


